import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { PythonUploadEdit } from 'components/PythonUploadEdit';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { formContainer, inputContainer, inputStyle } from 'modules/Models/components/ModelForm/styles';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { FormLabel } from './FormLabel';

type PythonFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & { path: string };

// labelTitle is passed as a prop to allow the Model Name and Model Id fields
// to reuse the same component as field type 2 elements.
export const PythonFormElement = ({ path }: PythonFormElementProps) => {
  const { values, setFieldValue } = useFormikContext();
  const { fieldValueMap } = values as FormikInitialValues;
  const { description = '' } = selectModelTypeFieldTypeInfo(path, values as FormikInitialValues);
  const formInputValue = fieldValueMap[path];

  const onValueChangeEditor = useCallback(
    (editorValue: string | undefined): void => {
      setFieldValue('fieldValueMap', { ...fieldValueMap, [path]: editorValue });
    },
    [fieldValueMap, path],
  );

  return (
    <div className={formContainer}>
      <div className={inputContainer}>
        <FormLabel path={path} description={description as string} />
        <div className={inputStyle}>
          <PythonUploadEdit value={formInputValue as string} onChange={onValueChangeEditor} />
        </div>
      </div>
    </div>
  );
};
